// Make sure formatting is hooked up on Android
require("./lib/intl/numberFormat");

// Export the Money type ("export default Money")
module.exports.Money = require("./lib/money").default;

// Include everything exported by the moneyFormatters module
Object.assign(module.exports, require("./lib/moneyFormatters"));
